import * as Sentry from '@sentry/angular';
import { INDEXED_DB_KEYS } from '../../../../shared/constants/indexed-db.constants';
import { LOCAL_STORAGE_PREFIXES } from '../../../../shared/constants/local-storage.constants';

export function getBrowserTabCounts(): number {
  const staleDateMs = 2000;
  let tabCount = 0;
  for (const key of Object.keys(localStorage))
    if (key.startsWith(LOCAL_STORAGE_PREFIXES.TAB)) {
      const now = Date.now();
      const value = localStorage.getItem(key)!;
      if (now - parseInt(value, 10) > staleDateMs) {
        localStorage.removeItem(key);
      } else tabCount += 1;
    }

  return tabCount;
}

export function clearFirebaseDbIfNoTabs() {
  const tabCount = getBrowserTabCounts();
  const navEntry = performance.getEntriesByType('navigation')[0] as
    | PerformanceNavigationTiming
    | undefined;

  if (navEntry?.type !== 'reload') {
    if (tabCount === 0) {
      const request = indexedDB.deleteDatabase(INDEXED_DB_KEYS.FIREBASE_LOCAL_STORAGE_DB);

      request.onsuccess = () => {
        console.log('firebaseLocalStorageDb deleted');
      };

      request.onerror = () => {
        console.error('Failed to delete firebaseLocalStorageDb');
        Sentry.captureException(request.error);
      };

      request.onblocked = () => {
        console.warn('Deletion blocked because the database is still open');
        Sentry.captureException(
          new Error('Deletion blocked because the firebaseLocalStorageDb is still open'),
        );
      };
    }
  }
}
